<template>
    <tr class="theather_article--info--content">
        <td><a :href="theater.theater_website" :title="theater.theater_name" target="_blank">{{theater.theater_name}}</a></td>
        <td><a :href="phoneNumber" :title="theater.theater_phone">{{theater.theater_phone}}</a></td>
        <td>{{theater.theater_date}}</td>
    </tr>
</template>

<script>
export default {
    name: 'theather-item',
    props: {
        theater: Object
    },
    data () {
        return {
        }
    },
    computed: {
        phoneNumber: function () {
            return 'tel:' + this.theater.theater_phone
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/TheatersItem.vue